<template>
<div>
    <div ref="drawerOverlay" class="mcc-drawer mcc-drawer--end mcc-drawer--w-md" id="drawerOverlay" type="modal">
        <div class="mu-d-flex mu-flex-column mu-h-100 mu-w-100">
            <div class="mcc-drawer__header mu-d-flex mu-justify-content-between">
                <h2 class="mu-fs-4">{{$props.title}}</h2>
                <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="close()">
                    <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                    <span class="mcc-button__label">Button</span>
                </button>
            </div>
            <div class="mcc-drawer__body mu-flex-grow-1 " style="overflow-x: hidden; overflow-y: scroll;">
                <slot></slot>
            </div>
            <div class="mcc-drawer__footer">
                <div class="mcc-button-group mcc-button-group--block mcc-button-group--spaced">
                    <button class="mcc-button mcc-button mcc-button--outline" @click="close()">Cancel</button>
                    <button class="mcc-button mcc-button mcc-button--outline" @click="resetFilter">Reset</button>
                    <button class="mcc-button mcc-button mcc-button--success" @click="applyFilter">Apply</button>
                </div>
            </div>
        </div>
    </div>
    <div class="mcc-drawer__scrim" @click="close">
    </div>
</div>
</template>

<script>
import constants from "../../constants";
export default {
    name: "Drawer",
    props: {
        title: {
            type: String,
            default: "Filters"
        },
    },
    methods: {
        resetFilter() {
            this.$emit('reset-filter')
            this.close();   
        },
        applyFilter() {
            this.$emit('apply-filter')
            // this.close();
        },
        close() {
            this.$refs.drawerOverlay.classList.remove("mcc-drawer--open")
            this.$refs.drawerOverlay.classList.add("mcc-drawer--closed")
        },
        open() {
            this.$refs.drawerOverlay.classList.remove("mcc-drawer--closed")
            this.$refs.drawerOverlay.classList.add("mcc-drawer--open")
        }
    }
}
</script>

<style scoped>
.mcc-drawer[type=modal] {
    z-index: 3008 !important;
}
</style>
